import { Component, Input, OnInit } from '@angular/core';
@Component({
  selector: 'anms-status-indicator',
  templateUrl: './statusIndicator.component.html',
  styleUrls: ['./statusIndicator.component.scss'],
  standalone: false
})
export class StatusIndicatorComponent implements OnInit {
  @Input() statusText!: string;
  @Input() statusColor!: string;
  constructor() {
  }

  ngOnInit() {
  }
}
